import YoutubeIcon from './youtube.svg';

export { YoutubeIcon };
